import React from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker, Polyline } from 'react-google-maps';
import { graphql, compose, Query } from 'react-apollo';
import polyline from '@mapbox/polyline';
import color from 'config/color';
import detailShipmentQuery from './graphql/query/detailShipment';
import googleMapsKey from 'config/googleMapsKey';
import { MarkerTime, InfoWindowTime } from './components';
import moment from 'moment';
import 'moment-duration-format';
import { client } from './../../../../../../index';
import firebase from 'firebase';
import firebaseConfig from 'config/firebaseConfig';
import axios from 'axios';
import mapuri from 'config/mapTrackingUri';

const pickupIcon = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAA0CAYAAADi1poDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAppJREFUeNrMWEuOozAQJUn3ZKZXHMGLrLLiCByBIzA34AjcgHVWzA2YA0QikUaa7Mh+FuQEgdUsppuudo0cyQLb2MFu8qQnlA/2c1XZVWXPswfizYiIMqesKEHAhrKkTFwK9SlTNhkYEsWFti1yj5A+C7awScgtCOm7M5BNthhxUal6GbHZbC7b7bZdr9ctfm6aJtjv961G7Hyn/GFimUK2SkII7Ha75nq9NiDB6XSq4zges1agKyYVDeD7PmRZBiao6xrCMFS5bzSmApmYqqrgXiisVYwJKm2L0RAVGlmnKAqwARrwEASBkZUGWxz9bxNlWcqsJIyl2pV1eEisFIuS4yB2XAB3qkAQesdbqrI1XYmTpCgZl/QFDXxI48eJINW4y94Omx28oEP/x7ZtnUx6uVy0BA1wPp+dCFKNywsa/OtwODix0vF4FOrUOodMk6kO8DgRbPtIJCgTlRp45NtCmqZGWZ+IjnVMijaACVpindy4ZM3z3FVihbHqksgKejT3vZZRiMl0NkIsKzsx+5vURrgIiZuA9XXaXYiy24ii6L8bsUQVlRhJkqiE3ALZuIm03QJptUJjSCyLqWy017FFMb6tEz95JDFTY2pSzIyhukNQ5LKGIoY3IZn3CdCNp9pF3Gh3uCYdqZNaXeNy6tOh2nWzXIISiZh8zs4lfxTryGKpfIT+rlZdGsyBhEsR1jrXKbh1vT+9B0Jtw11PE617I953/6L8TbmmfGcE9tTGylDEgi0CJ/1K+Y3xhfIv5R/2G/KZjX+7nAfdCUyAk3xhfOaeT9zi3ihfOf7j2Nl02aLHJfdcsbGAc1MneMdqDAFbPe+Cjn235HbsO/c9b6nOhcv4gF4x8oHt9SzUcQHuuRSkGgemDPQhwAC3qLvGM4GyJgAAAABJRU5ErkJggg==`;
const deliveryIcon = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAA0CAYAAADi1poDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4tJREFUeNrMWE1oE0EUnt02Fi2mSxE81J94UNCDNBfx1gjiwZMFoYpgE89CU+hBPajxoD0IRvBsW0G0ILQHTyI0vYh4SfCgoAejtYeCyDaxlZpk47zyFsfJzO7s7qz1wWPSMvP2m2++N/NmCNFgH/cfssB1xDJCfHyQNqPUoc1IupWoV6jPHPz8oRILIAokS5sb1FMB51ClXqDAprUAQkamkJEoBkzl/BgzFVgpawBDMEaZxsyHYogOBFayXoO7LKvaM3iUmL07YFmIs7ae2qi8JS3b9lvWacpUThkQzuKekNJkkvRdGLGT50dIYt9eYWY1vizZtSezZPXxrOXUajJQoKubvoAoGMicBVEE69Io6c9f3gSlYgDme/EBsR/OyLqcoKBKUkC4l5RFmbT77iTZeXY4lHjqz+bIysQVWQamKShbJuq8bjBgMBZiCCyF35Rm2ZhomaKAYUElxXHGhIAwxS1ewKAZXbbr+jWR/iz8dgdDQ3xPmJGqgFUMYklYGhIByoho1m2SmBkRoA4x9xw5rB2QJGbK9+jYfvwYicu8YpvM/vNf2CYgdmP6s8vWY/uoV2zpkm28ex8bIK/YJlev/GVrL15qByOJWREBKvG9avQM0m2SmCURoEXRbH6+fqMNDMSSMLQoO+0/8fsR7BsDTx9F3rGhFFk+d1GknypNqgMyURdEAvx263ZkdiCGRMwFvwJNWEP3njpJS4g7gZkCZlYmrkrFTNlJ+6U91Lq2SE9Lp88EyjyfMTZ+S6mmzuLVR2iJPQOkj9ZJcATwZxMsC4h3lZatja/LXnhzorua4XMFmoppb8zJLo6Gz70MyoI5vnCLYLBMw3xhH+bmuqABlI23jErkuz2CKkcElFZ5eDBVImGgXETNKL2CmKoRUYTFEGCKqi8fYd+Hgjw+dGx82hjiNs44+oYDhFooKHQtBH09C8sQQS3ZPikeRm/hAGENPu7RZVxUp8ciar/6ia9v/tWSSesnRX3FBmie05KN/9saQKgTFsB8WO3oYgjsvuT31hmIGwUe2bo1YSrpmlx3hKU2sDV/OM4r99ZEvQ21PeOxAurCMQlswc3n63X3iIAiroXeRG/g323dGyOA2cZ4gnF3Yi0GxC/0BtNqZcjg3ESQrruTc9jl5Ma0dQJqMbN0ddJEMCYDxmFYaiI7zTiWjBU0y47JxGEF7WopkLANTdnKxmlHCfRbgAEAE2xXcf+7pL4AAAAASUVORK5CYII=`;
const driverIcon = `data:image/png;base64,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`;

const GoogleMapsWrapper = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      {...props}
      ref={c => {
        props.onMapMounted && props.onMapMounted(c);
      }}
    >
      {props.children}
    </GoogleMap>
  ))
);

const google = (window.google = window.google ? window.google : {});

class GoogleMaps extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      fitBounds: true,
      isTracking: false,
      polyline: {
        distance: 0,
        duration: 0,
        coordinates: [],
      },
      polylineList: [],
      trackingLatitude: 0,
      trackingLongitude: 0,
      trackingSpeed: 0,
      trackingActivity: '',
    };

    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
    }
  }

  componentDidMount() {
    // this.polylineListDecode();
    this.getGpsData();
  }

  getGpsData = async () => {
    try {
      const { data } = await client.query({
        query: detailShipmentQuery,
        variables: {
          _id: this.props.shipmentId,
        },
        fetchPolicy: 'network-only',
      });

      const driverId = data.shipmentList.shipment[0].driver_user_id;
      firebase
        .database()
        .ref(`/gps/${driverId}`)
        .limitToLast(1)
        .on('value', async snapshot => {
          if (snapshot.numChildren() === 1) {
            snapshot.forEach(child => {
              const val = child.val();
              this.setState(
                {
                  trackingLatitude: val.location.coords.latitude,
                  trackingLongitude: val.location.coords.longitude,
                  trackingSpeed: val.location.coords.speed > 0 ? val.location.coords.speed : 0,
                  trackingActivity: val.location.activity ? val.location.activity.type : '',
                },
                // async () => {
                //   const data = await this.fetchPolyline();
                //   const { polyline: polylineEncode, duration, distance } = data;

                //   if (polylineEncode === null) {
                //     this.setState({
                //       polyline: {
                //         distance: 0,
                //         duration: 0,
                //         coordinates: [],
                //       },
                //     });

                //     return;
                //   }

                //   this.polylineDecode(polylineEncode, duration, distance);
                // }
              );
            });
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  fitBounds(shipmentAddress) {
    const { trackingLatitude, trackingLongitude, trackingSpeed, trackingActivity } = this.state;

    const shipmentListFilter = shipmentAddress
      .map((item, index) => ({ ...item, index }))
      .filter(item => item.mode !== 'roundtrip');
    if (shipmentListFilter.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();
      shipmentListFilter.forEach((item, index) => {
        bounds.extend(new window.google.maps.LatLng(Number(item.lat), Number(item.lng)));
      });

      if (trackingLatitude !== 0 && trackingLongitude !== 0) {
        bounds.extend(new window.google.maps.LatLng(trackingLatitude, trackingLongitude));
      }

      if (this.state.fitBounds) {
        this._map.fitBounds(bounds);
        this.setState({
          fitBounds: false,
        });
      }
    }
  }

  fitBoundsDriver = () => {
    const { trackingLatitude, trackingLongitude } = this.state;
    if (trackingLatitude !== 0 && trackingLongitude !== 0) {
      const bounds = new window.google.maps.LatLngBounds();
      bounds.extend(new window.google.maps.LatLng(trackingLatitude, trackingLongitude));
      if (this.state.fitBounds) {
        this._map.fitBounds(bounds);
        this.setState({
          fitBounds: false,
        });
      }
    }
  };

  getMarker(shipmentAddress) {
    const shipmentListFilter = shipmentAddress
      .map((item, index) => ({ ...item, index }))
      .filter(item => item.mode !== 'roundtrip');
    if (shipmentListFilter.length > 0) {
      if (google.maps === undefined) {
        return shipmentListFilter.map((item, index) => (
          <Marker
            key={index}
            icon={{
              url: item.mode === 'รับสินค้า' ? pickupIcon : deliveryIcon,
            }}
            position={{
              lat: parseFloat(item.lat),
              lng: parseFloat(item.lng),
            }}
          />
        ));
      }

      return shipmentListFilter.map((item, index) => (
        <Marker
          key={index}
          icon={{
            labelOrigin: new google.maps.Point(19, 16),
            url: item.mode === 'รับสินค้า' ? pickupIcon : deliveryIcon,
          }}
          position={{
            lat: parseFloat(item.lat),
            lng: parseFloat(item.lng),
          }}
          label={{
            color: '#000000',
            fontWeight: 'bold',
            fontSize: '18px',
            lineHeight: '20px',
            text: (item.index + 1).toString(),
          }}
        />
      ));
    }

    return null;
  }

  getDriverMarker = () => {
    const { trackingLatitude, trackingLongitude, trackingSpeed, trackingActivity } = this.state;
    if (trackingLatitude !== 0 && trackingLongitude !== 0) {
      return (
        <React.Fragment>
          <Marker
            icon={{
              url: driverIcon,
            }}
            position={{
              lat: Number(this.state.trackingLatitude),
              lng: Number(this.state.trackingLongitude),
            }}
          >
            {this.state.polyline.coordinates.length >= 2 && (
              <InfoWindowTime
                title={this.getFormatTime(this.state.polyline.duration)}
                subTitle={`ระยะทาง ${this.state.polyline.distance.toLocaleString('en-US', {
                  maximumFractionDigits: 2,
                })} กม.`}
                trackingSpeed={`ความเร็ว ${(trackingSpeed * 3.6).toLocaleString('en-US', {
                  maximumFractionDigits: 0,
                })} กม./ชม.`}
                trackingActivity={`Activity : ${trackingActivity}`}
                lat={Number(this.state.trackingLatitude)}
                lng={Number(this.state.trackingLongitude)}
              />
            )}
          </Marker>
        </React.Fragment>
      );
    }

    return null;
  };

  getPolyline(shipment) {
    const { shipment_type, shipment_status } = shipment;

    return (
      <React.Fragment>
        {/* polyline shipment detail */}
        {/* duration shipment detail */}
        {shipment_type === 1 &&
        shipment_status !== 4 &&
        shipment_status !== 5 &&
        shipment_status !== 6 &&
        this.props.isHideDriver
          ? this.state.polylineList.map((item, index) => (
              <React.Fragment>
                <Polyline
                  key={index}
                  path={item.coordinates}
                  options={{
                    strokeColor: color.Blue,
                    strokeWeight: 6,
                  }}
                />

                {this.state.polylineList
                  .filter(item => item.coordinates.length >= 2)
                  .map((item, index) => (
                    <MarkerTime
                      key={index}
                      title={this.getFormatTime(item.duration)}
                      subTitle={`ระยะทาง ${item.distance.toLocaleString('en-US', {
                        maximumFractionDigits: 2,
                      })} กม.`}
                      lat={this.getLatLngPolylineCenter(item.coordinates).lat}
                      lng={this.getLatLngPolylineCenter(item.coordinates).lng}
                    />
                  ))}
              </React.Fragment>
            ))
          : null}

        {/* polyline socket io */}
        {/* duration socket io */}
        {shipment_type === 1 &&
        !this.props.isHideDriver &&
        this.state.polyline.coordinates.length >= 2 ? (
          <React.Fragment>
            <Polyline
              path={this.state.polyline.coordinates}
              options={{
                strokeColor: color.Blue,
                strokeWeight: 6,
              }}
            />
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }

  polylineDecode(polylineEncode, duration, distance) {
    try {
      this.setState({
        polyline: {
          duration,
          distance,
          coordinates: polyline.decode(polylineEncode).map(point => {
            return {
              lat: point[0],
              lng: point[1],
            };
          }),
        },
      });
    } catch (error) {
      console.log(error);
    }
  }

  async fetchPolyline() {
    try {
      const { trackingLatitude, trackingLongitude } = this.state;

      const param = {
        lat: trackingLatitude,
        lng: trackingLongitude,
        shipment_id: this.props.shipmentId,
      };

      const res = await axios.post(`${mapuri}/driver-track-polyline`, param);
      return res.data;
    } catch (error) {
      console.log(error);
    }

    return null;
  }

  async polylineListDecode() {
    try {
      const { data } = await client.query({
        query: detailShipmentQuery,
        variables: {
          _id: this.props.shipmentId,
        },
        fetchPolicy: 'network-only',
      });

      const polylineListEncode = data.shipmentList.shipment[0].polyline_list;
      const polylineListDecode = polylineListEncode.map(polylineEncode => ({
        duration: polylineEncode.duration,
        distance: polylineEncode.distance,
        coordinates: polyline.decode(polylineEncode.polyline).map(point => {
          return {
            lat: point[0],
            lng: point[1],
          };
        }),
      }));

      this.setState({
        polylineList: polylineListDecode,
      });
    } catch (error) {
      console.log(error);
    }
  }

  getLatLngPolylineCenter(coordinates) {
    const coordinateCenterIndex = coordinates.length / 2 - 1;

    return {
      lat: coordinates[Math.floor(coordinateCenterIndex)].lat,
      lng: coordinates[Math.floor(coordinateCenterIndex)].lng,
    };
  }

  getFormatTime(second) {
    return moment.duration(second, 'second').format(`D [ว.] HH [ชม.] mm [นาที]`, {
      trunc: true,
      trim: 'both',
    });
  }

  render() {
    return (
      <Query
        query={detailShipmentQuery}
        variables={{
          _id: this.props.shipmentId,
        }}
      >
        {({ loading, error, data }) => {
          if (loading) return null;
          if (error) return null;

          return (
            <GoogleMapsWrapper
              loadingElement={<div style={{ height: `100%` }} />}
              containerElement={<div style={{ height: '100%' }} />}
              mapElement={<div style={{ height: `100%` }} />}
              googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${googleMapsKey}&v=3.exp&libraries=geometry,drawing,places`}
              zoom={15}
              options={{
                mapTypeControl: false,
                panControl: false,
                streetViewControl: true,
                minZoom: 5,
                maxZoom: 18,
              }}
              defaultCenter={{
                lat: 13.664273,
                lng: 100.653512,
              }}
              // onIdle={() => this.fitBounds(data.shipmentList.shipment[0].shipment_address)}
              onIdle={() => {
                if (this.props.isHideDriver === false) {
                  setTimeout(() => {
                    this.fitBoundsDriver();
                  }, 2000);
                }
              }}
              onMapMounted={c => (this._map = c)}
            >
              {/* {this.getMarker(data.shipmentList.shipment[0].shipment_address)} */}
              {/* { this.getPolyline(data.shipmentList.shipment[0]) } */}
              {this.props.isHideDriver === false && this.getDriverMarker()}
            </GoogleMapsWrapper>
          );
        }}
      </Query>
    );
  }
}

export default compose(
  graphql(detailShipmentQuery, {
    name: 'detailShipmentQuery',
    options: props => ({
      fetchPolicy: 'cache-and-network',
      variables: {
        _id: props.shipmentId,
      },
    }),
  })
)(GoogleMaps);
